export enum ActionNeededTypes {
    NeedsAction = -1,
    DocumentNeeded = -2,
    BeAdvised = -3,
    DocumentReviewNeeded = -4
}